import { gql } from '@urql/core';
import React from 'react';
import { CollegeInfoButtonsFragment } from '../../../generated/spin-graphql';
import { PhoneIcon } from '../../svg/PhoneIcon';
import { DiscordIcon } from '../../svg/socials/DiscordIcon';

type Props = {
    college: CollegeInfoButtonsFragment;
};

gql`
    fragment CollegeInfoButtons on espin_college {
        slug
        contact_email
        phone
        socials {
            discord
        }
    }
`;

export const CollegeInfoButtons: React.FC<Props> = ({ college }) => {
    return (
        <div className="info-button-container">
            {college.socials?.discord && (
                <p className="info-button discord">
                    <DiscordIcon />
                    {college.socials.discord}
                </p>
            )}
            {college.contact_email && (
                <a href={`mailto:${college.contact_email}`} className="info-button">
                    {college.contact_email}
                </a>
            )}
            {college.phone && (
                <a href={`tel:${college.phone}`} className="info-button">
                    <PhoneIcon />
                    {college.phone}
                </a>
            )}
        </div>
    );
};
